/**
 * @file: 画布插入组件坐标计算
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as Toolkit from '../../toolkit/index';
import * as UIToolkit from '../../UIToolkit/index';
import Utils from '../../utils/util';
import FrontCubeData from '../../frontCubeData/index';
import CodiSystem from '../../codiSystem/index';
import Config from '../../config/index';

const maxDropWidth: PhysicsMeasurement = Config.get({
    moduleName: 'sketchpad',
    key: 'maxDropWidth'
});
const defaultLayerHeight: PhysicsMeasurement = Config.get({
    moduleName: 'layer',
    key: 'defaultLayerHeight'
});
const maxTopLine: LogicsicsMeasurement = Toolkit.cmToPx(Config.get({
    moduleName: 'shelf',
    key: 'maxHeight'
}));

function insertToStagePosition(cubeId: CubeId): PhysicsPosition {
    let cubePhysicsRelativeCoordinate: PhysicsRelativeCoordinate = CodiSystem.getRelativePhysicsCoordinate(cubeId);
    let stageFooterIsEmpty: boolean = UIToolkit.stageFooterIsEmpty();

    if (stageFooterIsEmpty) {
        // 画布下侧是空的
        return insertToEmptyStage(cubeId, cubePhysicsRelativeCoordinate);
    }

    let cubeInStage: Array<CubeId> = CubeTree.findCubeInStage();
    let logicCoordinates: Array<LogicCoordinate> = CodiSystem.getLogicCoordinates(cubeInStage);
    let bootomRightRect: Rect|null = Toolkit.theBottomRect(logicCoordinates);
    let bootomRightRectPhysics: PhysicsCoordinate = CodiSystem.logicToPhysics(bootomRightRect);
    let left: PhysicsMeasurement = Utils.math(bootomRightRectPhysics.left, bootomRightRectPhysics.width, '+');
    let bottom: PhysicsMeasurement = bootomRightRectPhysics.bottom;

    // 右侧越界，换行
    if (left > maxDropWidth) {
        let dis: number = Utils.math(cubePhysicsRelativeCoordinate.height, 10, '+');

        left = 0;
        bottom = Utils.math(bottom, dis, '-');

        if (CubeTree.isLayer(cubeId) || CubeTree.isDishrack(cubeId)) {
            // 需要加放置区域高度
            let dropHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(cubeId, 'layerHeight');

            if (dropHeight <= 0) {
                dropHeight = defaultLayerHeight;
            }

            bottom = Utils.math(bottom, dropHeight, '-');
        }
    }

    return {
        left,
        bottom
    };
}

// 向空画布中添加，算坐标
function insertToEmptyStage(cubeId: CubeId, coordinate: PhysicsRelativeCoordinate): PhysicsPosition {
    let bottom: PhysicsMeasurement = Utils.math(coordinate.height, 25, '+');

    if (CubeTree.isLayer(cubeId) || CubeTree.isDishrack(cubeId)) {
        // 需要加放置区域高度
        let dropHeight: PhysicsMeasurement = FrontCubeData.getNumberValue(cubeId, 'layerHeight');

        if (dropHeight <= 0) {
            dropHeight = defaultLayerHeight;
        }

        bottom = Utils.math(dropHeight, bottom, '+');
    }

    return {
        left: 0,
        bottom: -bottom
    };
}

export {
    insertToStagePosition
};
